import { render, staticRenderFns } from "./StorageCN_edit.vue?vue&type=template&id=4b03998d&scoped=true&"
import script from "./StorageCN_edit.vue?vue&type=script&lang=js&"
export * from "./StorageCN_edit.vue?vue&type=script&lang=js&"
import style0 from "./StorageCN_edit.vue?vue&type=style&index=0&id=4b03998d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b03998d",
  null
  
)

export default component.exports